export default {"src":"/_next/static/media/bitwala.8c06bd02.svg","height":45,"width":184,"blurWidth":0,"blurHeight":0};